const SEARCH_LIMIT = 50;

class TrieNode {
  children: Map<string, TrieNode>;
  isEndOfWord: boolean;
  words: string[];

  constructor() {
    this.children = new Map();
    this.isEndOfWord = false;
    this.words = [];
  }
}

export class Trie {
  root: TrieNode;

  constructor() {
    this.root = new TrieNode();
  }

  insert(word: string): void {
    let currentNode = this.root;
    if (currentNode.words.length < SEARCH_LIMIT) {
      currentNode.words.push(word);
    }
    for (const char of word) {
      if (!currentNode.children.has(char)) {
        currentNode.children.set(char, new TrieNode());
      }

      currentNode = currentNode.children.get(char)!;

      if (currentNode.words.length < SEARCH_LIMIT) {
        currentNode.words.push(word);
      }
    }
    currentNode.isEndOfWord = true;
  }

  search(prefix: string, limit: number = SEARCH_LIMIT): string[] {
    if (!prefix) {
      return this.root.words.slice(0, limit);
    }

    let currentNode = this.root;
    for (const char of prefix) {
      const child = currentNode.children.get(char);
      if (child === undefined) {
        return [];
      }
      currentNode = child;
    }

    return currentNode.words.slice(0, limit);
  }
} 